import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginButton from '../components/auth/LoginButton';
const LoginPage: React.FC = () => {
  const {
    user,
    loading,
    error
  } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!loading && user) {
      // If user has an approved role, redirect to dashboard
      if (user.role && user.role !== 'pending' && user.role !== 'reader') {
        navigate('/dashboard');
      }
    }
  }, [user, loading, navigate]);
  return <div className="w-full bg-lightGray" data-id="element-1450">
      <div className="container-custom py-16" data-id="element-1451">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-1452">
          <h1 className="text-2xl font-bold text-navy mb-6 font-montserrat text-center" data-id="element-1453">
            Sign In to Operation Launchpad
          </h1>
          {error && <div className="mb-6 p-4 bg-red-50 text-red-700 rounded-md" data-id="element-1454">
              <p className="font-bold" data-id="element-1455">Error:</p>
              <p data-id="element-1456">{error}</p>
              <p className="mt-2 text-sm" data-id="element-1457">
                Please check that your Firestore database is set up correctly in
                the Firebase Console.
              </p>
            </div>}
          {loading ? <div className="flex justify-center py-8" data-id="element-1458">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-navy" data-id="element-1459"></div>
            </div> : user ? <div className="text-center" data-id="element-1460">
              {user.role === 'pending' ? <>
                  <div className="mb-6 p-4 bg-yellow-50 text-yellow-700 rounded-md" data-id="element-1461">
                    Your account is pending approval. Once approved, you'll be
                    able to access the dashboard.
                  </div>
                  <button onClick={() => navigate('/')} className="btn-secondary" data-id="element-1462">
                    Return to Home
                  </button>
                </> : user.role === 'reader' ? <>
                  <div className="mb-6 p-4 bg-blue-50 text-blue-700 rounded-md" data-id="element-1463">
                    You're signed in as a reader. You can now leave comments on
                    articles.
                  </div>
                  <button onClick={() => navigate('/enews')} className="btn-primary" data-id="element-1464">
                    Browse Articles
                  </button>
                </> : <>
                  <div className="mb-6 p-4 bg-green-50 text-green-700 rounded-md" data-id="element-1465">
                    You're already signed in. You can access the dashboard.
                  </div>
                  <button onClick={() => navigate('/dashboard')} className="btn-primary" data-id="element-1466">
                    Go to Dashboard
                  </button>
                </>}
            </div> : <div className="text-center" data-id="element-1467">
              <p className="mb-8 text-gray-600" data-id="element-1468">
                Sign in with your Google account to access the Operation
                Launchpad dashboard or to comment on articles.
              </p>
              <div className="flex justify-center" data-id="element-1469">
                <LoginButton data-id="element-1470" />
              </div>
              <p className="mt-6 text-sm text-gray-500" data-id="element-1471">
                New contributors will need approval from an administrator before
                gaining access to the dashboard.
              </p>
            </div>}
        </div>
      </div>
    </div>;
};
export default LoginPage;